export type { Dictionary } from './I18n';
export { i18n, I18nProvider, useI18n } from './context';
